import clientInfo from 'common/lib/clientInfo';

type ChatSessionInitialData = {
  firstOpenedArea?: string;
};

type ChatSessionData = ChatSessionInitialData & {
  startedAt?: number;
};

// This hook is used to track the start and end of a chat session in the same tab.
const useChatSession = () => {
  const storageKey = 'kjb_copyMagic_conversationAssistant'.concat(
    '_userId',
    clientInfo.get('user_id'),
    '_chatSession',
  );

  const isChatSessionInProgress = () => !!sessionStorage.getItem(storageKey);

  const startChatSession = (initialData: ChatSessionInitialData) => {
    if (isChatSessionInProgress()) {
      return;
    }

    const sessionData: ChatSessionData = {
      startedAt: Date.now(),
      ...initialData,
    };

    sessionStorage.setItem(storageKey, JSON.stringify(sessionData));
  };

  const endChatSession = () => {
    sessionStorage.removeItem(storageKey);
  };

  const chatSessionData = () => {
    const defaultData: ChatSessionData = {};
    const rawData = sessionStorage.getItem(storageKey);
    if (!rawData) return defaultData;

    let data: ChatSessionData = defaultData;
    try {
      data = JSON.parse(rawData);
    } catch (error) {
      // no-op
    }
    const { startedAt, firstOpenedArea } = data;

    return {
      startedAt,
      firstOpenedArea,
    };
  };

  return {
    startChatSession,
    endChatSession,
    isChatSessionInProgress,
    chatSessionData,
  };
};

export default useChatSession;
